<template>
    <svg
      aria-hidden="true"
      class="h-full w-full text-red-cc dark:text-white"
      focusable="false"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        :class="['transition-opacity duration-300 ease-in-out', animate ? 'opacity-0' : 'opacity-100']"
        fill="currentColor"
        d="M21,12.9H3c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h18c0.5,0,0.9,0.4,0.9,0.9S21.5,12.9,21,12.9z"
      />
      <path
        :class="['transition-transform duration-300 ease-in-out', animate ? 'rotate-45 translate-x-[20%] -translate-y-[10%]' : '']"
        fill="currentColor"
        d="M21,6.9H3C2.5,6.9,2.1,6.5,2.1,6S2.5,5.1,3,5.1h18c0.5,0,0.9,0.4,0.9,0.9S21.5,6.9,21,6.9z"
      />
      <path
        :class="['transition-transform duration-300 ease-in-out', animate ? '-rotate-45 -translate-x-[55%] translate-y-[25%]' : '']"
        fill="currentColor"
        d="M21,18.9H3c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h18c0.5,0,0.9,0.4,0.9,0.9S21.5,18.9,21,18.9z"
      />
      <circle class="sb-icon-hover" cx="50%" cy="50%" fill="transparent" r="75%" />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconBurger',
    props: {
      animate: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>